import React from 'react';
import './customModal.css';
const CustomModal = ({ setIsModalOpen, isModalOpen, children, type }) => {
    
  return (
      <>
        {isModalOpen && (
            <div className="modal-wrapper" >
              <div
                  className={`modal-content 
                  ${type === 'confirm' ? 'confirmModal' : ''} 
                  ${type === 'error' ? 'error' : ''} 
                  ${type === 'contact' ? 'contact' : ''}`}
              >
                  {children}
              </div>
            </div>

        )}
      </>
  );
};

export default CustomModal;
